var map = {
	"./china.png": "7926",
	"./south.png": "7b5f",
	"./北京.png": "0c38",
	"./张家口.png": "35e1",
	"./深圳.png": "bcc9",
	"./深圳龙岗.png": "bd66",
	"./湖州.png": "5436"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d30";